var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ReactSurveyElement } from "./reactquestion_element";
var SurveyQuestionOptionItem = /** @class */ (function (_super) {
    __extends(SurveyQuestionOptionItem, _super);
    function SurveyQuestionOptionItem(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { changed: 0 };
        _this.setupModel();
        return _this;
    }
    SurveyQuestionOptionItem.prototype.componentDidUpdate = function (prevProps, prevState) {
        _super.prototype.componentDidUpdate.call(this, prevProps, prevState);
        this.setupModel();
    };
    SurveyQuestionOptionItem.prototype.componentDidMount = function () {
        _super.prototype.componentDidMount.call(this);
        this.setupModel();
    };
    SurveyQuestionOptionItem.prototype.componentWillUnmount = function () {
        _super.prototype.componentWillUnmount.call(this);
        if (!!this.item) {
            this.item.locText.onChanged = function () { };
        }
    };
    SurveyQuestionOptionItem.prototype.setupModel = function () {
        if (!this.item.locText)
            return;
        var self = this;
        this.item.locText.onChanged = function () {
            self.setState({ changed: self.state.changed + 1 });
        };
    };
    SurveyQuestionOptionItem.prototype.getStateElement = function () {
        return this.item;
    };
    Object.defineProperty(SurveyQuestionOptionItem.prototype, "item", {
        get: function () {
            return this.props.item;
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionOptionItem.prototype.canRender = function () {
        return !!this.item;
    };
    SurveyQuestionOptionItem.prototype.renderElement = function () {
        return (React.createElement("option", { value: this.item.value, disabled: !this.item.isEnabled }, this.item.text));
    };
    return SurveyQuestionOptionItem;
}(ReactSurveyElement));
export { SurveyQuestionOptionItem };
